/**
 * VB New - Testimonios
 * Las miniaturas cambian el video del reproductor principal (snippet video-player).
 * La reproducción se dispara con el botón del snippet para que sus estados
 * (íconos, audio, aria-label) se mantengan sincronizados.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.vbnReady) return;
    root.dataset.vbnReady = 'true';

    var player = root.querySelector('[data-vp]');
    var thumbs = root.querySelectorAll('[data-vbn-testimonio]');
    if (!player || !thumbs.length) return;

    var video = player.querySelector('[data-vp-video]');
    var playButton = player.querySelector('[data-vp-btn]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-video-url');
        if (!url || !video) return;

        var poster = thumb.getAttribute('data-poster');
        if (poster) video.setAttribute('poster', poster);

        video.pause();
        player.classList.remove('is-playing');
        video.src = url;
        video.load();

        if (playButton) {
          playButton.click();
        } else {
          video.play().catch(function (error) {
            console.log('[VBN Testimonios] No se pudo reproducir:', error);
          });
        }

        thumbs.forEach(function (item) {
          var active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    console.log('[VBN Testimonios] Inicializado con', thumbs.length, 'videos');
  }

  function initAll() {
    document.querySelectorAll('[data-vbn-testimonios]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-vbn-testimonios]'));
  });
})();
